import NewMessageContainer from './NewMessageContainer'

export default NewMessageContainer
